import { createSlice } from "@reduxjs/toolkit";

export interface ITakesInitialState{
	clients: [];
	updating: boolean;
	gettingList: boolean;
	isError: boolean;
	errorCode: number;
	errorMessage: string|string[]|null;
}

export const initialState: ITakesInitialState = {
	clients: [],
	updating: false,
	gettingList: false,
	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const TakesSlice = createSlice({
	name: 'takes',
	initialState,
	reducers: {

		clearTakes: (state, action) => {
			return { ...state, clients: [] };
		},

		onLoadUpdate: (state, action ) => {
			return { ...state, updating: true };
		},

		onLoadList: (state, action ) => {
			return { ...state, gettingList: true };
		},

		// Success
		onSuccessUpdate: (state, action) => {
			return {
				...state,
				clients: action.payload.data,
				updating: false,
			};
		},

		onSuccessList: (state, action) => {
			return {
				...state,
				clients: action.payload.data,
				gettingList: false,
			};
		},

		// Errors
		onFailUpdate: (state, action) => {
			return { ...state, updating: false };
		},
		onFailList: (state, action) => {
			return { ...state, clients: [] };
		},
	},
});

export const {
	clearTakes,
} = TakesSlice.actions;
